import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PowerBiComponent } from './power-bi.component';
import { SharedModule } from '../../../core/modules/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { SelectorModule } from '../selector/selector.module';

const routes: Routes = [
    {
        path     : 'power-bi',
        component: PowerBiComponent,
        /* resolve  : {
            data: DashboardService
        } */
    },
    /* {
        path     : 'dashboard/:activoSeleccionado',
        component: FuseDashboardComponent,
        resolve  : {
            data: DashboardService
        }
    } */
];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(routes),
    SelectorModule
  ],
  declarations: [PowerBiComponent]
})
export class PowerBiModule { }



// WEBPACK FOOTER //
// ./src/app/main/content/power-bi/power-bi.module.ts